import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Region extends EntityDto implements IEntityDto {
    Region_Id: string;
    RegionName: string; 
    Code:string;
    Emp_Ref_Id: string;
    EmployeeName: string;
    Phone: string;
    EmailId: string;
    Company_Id: string;
    CompanyName: string;
    Zone_Id: string;
    ZoneName: string;
    State_Id: string;
    StateName: string;
    TotalCount: number;
    IsActive: boolean;
    
    constructor() {
        super();
        this.Region_Id = "00000000-0000-0000-0000-000000000000";
        this.RegionName = "";
        this.Code="";
        this.EmailId = "";
        this.Phone = "";
        this.Emp_Ref_Id = '';
        this.EmployeeName = '';
        this.Company_Id = "";
        this.CompanyName = ""; 
        this.Zone_Id = "";
        this.ZoneName = ""; 
        this.State_Id = "";
        this.StateName = ""; 
        this.TotalCount = 0; 
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'RegionName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Region Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' }, 
            { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Email is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Region Head is required' },    
            //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            //{ FieldName: 'Zone_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone is required' },     
            //{ FieldName: 'State_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'State is required' },     
        ];
    }
}
